import React from 'react'; 
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Text, Spinner, HStack } from '@chakra-ui/react';
import '../styles/components/ConfirmModal.css';

const ConfirmModal = ({ isOpen, onClose, onConfirm, appointment, actionType, isLoading }) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay className="modal-overlay" />
        <ModalContent className="modal-content">
            <ModalHeader className="modal-header">
                Confirm {actionType === 'cancel' ? 'Cancellation' : actionType === 'book' ? 'Booking' : 'Reschedule'}
            </ModalHeader>
            <ModalCloseButton className="close-button" />
            <ModalBody className="modal-body">
                <Text className="modal-body-text modal-question">
                    Are you sure you want to {actionType} this appointment?
                </Text>
                <div className="appointment-details">
                    <Text className="modal-body-text">
                        <strong>Title:</strong> {appointment.AppointmentTitle}
                    </Text>
                    <Text className="modal-body-text">
                        <strong>Date:</strong> {new Date(appointment.AptDateTime).toLocaleDateString()}
                    </Text>
                    <Text className="modal-body-text">
                        <strong>Time:</strong> {new Date(appointment.AptDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </Text>
                </div>
                
                {isLoading && (
                    <HStack className="loading-container">
                        <Spinner className="loading-spinner" />
                        <Text className="loading-text">
                            {actionType === 'cancel'
                                ? 'Cancelling appointment...'
                                : actionType === 'book'
                                    ? 'Booking appointment...'
                                    : 'Rescheduling appointment...'}
                        </Text>
                    </HStack>
                )}
            </ModalBody>
            <ModalFooter className="modal-footer">
                <HStack spacing={3}>
                    <Button 
                        className={`modal-button confirm-button ${actionType}-action`}
                        colorScheme={actionType === 'cancel' ? 'red' : actionType === 'book' ? 'blue' : 'green'}
                        onClick={onConfirm} 
                        isDisabled={isLoading}
                    >
                        Yes, {actionType === 'cancel' ? 'Cancel' : actionType === 'book' ? 'Book' : 'Reschedule'}
                    </Button>
                    <Button 
                        className="modal-button cancel-button"
                        onClick={onClose} 
                        isDisabled={isLoading}
                    >
                        No, Go Back
                    </Button>
                </HStack>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

export default ConfirmModal;